import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { US_ONLY_COUNTRY_OPTIONS } from '@shared/utils/address/constants';
import { useStationeryCountryList } from '@shared/utils/address/useStationeryCountryList';

/**
 * The countries a stationery order of this category can ship to: card_service's sellable countries, except
 * signs, which are US-only. We saw international sign orders quoted around $500 in shipping, and that has
 * not changed.
 *
 * Shared by the shipping address dropdown and the warning that names the allowed countries, so the two
 * always agree.
 */
export const useShippingCountryList = (category: StationeryTemplateCategoryEnum | null | undefined) => {
  // Called unconditionally to keep hook order stable.
  const sellableCountries = useStationeryCountryList();
  return category === StationeryTemplateCategoryEnum.sign ? US_ONLY_COUNTRY_OPTIONS : sellableCountries;
};
